import { createSlice } from "@reduxjs/toolkit";
import { CampaignPermalinksSlice } from "types/campaign/permalinks";
import { fetchCampaignPermalinksThunk } from "./thunk";
import { ERROR } from "types";

const initialState: CampaignPermalinksSlice = {
    error: null,
    loading: true,
    campaigns: {},
    applied_filter_id: null,
    filters: {page: 1},
    status_counts: []
}

const campaignPermalinkSlice = createSlice({
    name: 'campaignPermalinks',
    initialState,
    reducers: {
        updateCampaignPermalinksFilter: (state, {payload}) => {
            state.filters = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignPermalinksThunk.pending, (state) => {
                state.error = null;
                state.loading = true;
            })
            .addCase(fetchCampaignPermalinksThunk.fulfilled, (state, {payload}) => {
                const {permalinks, filters, filterId, campaignId} = payload;
                state.loading = false;
                state.error = null;
                const existingData = state.campaigns?.[campaignId]?.filtered_lists?.[filterId]?.list ?? [];
                const list = filters.page === 1 ? permalinks.items : [...existingData, ...permalinks.items];
                state.campaigns[campaignId] = {
                    ...(state.campaigns[campaignId] ?? {}),
                    filtered_lists: {
                        ...(state.campaigns[campaignId]?.filtered_lists ?? {}),
                        [filterId]: {
                            list,
                            page: filters.page,
                            expired: false,
                            last_fetched_at: Date.now(),
                            has_more: permalinks.count > list.length,
                            filters: filters,
                            count: permalinks.count
                        }
                    }
                }
                state.applied_filter_id = filterId;
                state.status_counts = permalinks.status_counts;
            })
            .addCase(fetchCampaignPermalinksThunk.rejected, (state, { payload }) => {
                state.loading = false;
                if (payload !== ERROR.CACHED)
                    state.error = payload || "Failed to fetch collaborations!"
            })
    }
})

export const {updateCampaignPermalinksFilter} = campaignPermalinkSlice.actions;
export default campaignPermalinkSlice.reducer;